import TemplateView from '../../../TemplateView'
import CustomCheckbox from '../../../components/customCheckbox/CustomCheckbox'

export default class RequirementCheckbox extends TemplateView {

    constructor({
        label = "",
        value = "",
        onValueChange = "",
        disabled = false
    } = {}) {
        super();
        this.label = label;
        this.state = {
            value, onValueChange, disabled
        };
        this.onStatePropertyChanged("disabled", disabled => this.checkbox.setState({disabled}));
        this.onStatePropertyChanged("value", value => this.checkbox.setState({checked: value}));
    }

    templateHtml() {
        return "<div></div>"
    }

    afterRender() {
        this.checkbox = new CustomCheckbox({
            label: this.label,
            onChange: ({checked}) => this.state.onValueChange(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
            checkboxTitleAdditionalClass: 'passwordSettings_label'
        }).init(this.getEl());
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/components/RequirementCheckbox.js